import Game from "~/src/scenes/Game";

export function handlePlayerEatDot(this: Game, hero: Phaser.GameObjects.GameObject, dot: Phaser.GameObjects.GameObject) {
  this._eatenDots.push(dot.name);
  return this.hero?.eatDot(dot as Phaser.Physics.Arcade.Sprite);
}

export function handlePlayerEatPowerDot(this: Game, hero: Phaser.GameObjects.GameObject, energizer: Phaser.GameObjects.GameObject) {
  this._eatenEnergizers.push(energizer.name);
  this.hero?.eatPowerDot(energizer as Phaser.Physics.Arcade.Sprite);
}

export function handlePlayerEatFruit(this: Game, hero: Phaser.GameObjects.GameObject, fruit: Phaser.GameObjects.GameObject) {
  if (fruit.active) {
    this.hero?.eatFruit(fruit as Phaser.Physics.Arcade.Sprite);
  }
}